export type BreakpointKey = 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
type Breakpoints = Record<BreakpointKey, number>;

export const breakpoints: Breakpoints = {
  xxl: 1921,
  xl: 1920,
  lg: 1440,
  md: 1200,
  sm: 768,
};

export type MediaQueryType = 'min' | 'max';

const getCurrentBreakpoint = (): BreakpointKey => {
  if (typeof window === 'undefined') return 'xl'; // fallback for SSR
  const width = window.innerWidth;
  if (width >= breakpoints.xxl) return 'xxl';
  if (width >= breakpoints.xl) return 'xl';
  if (width >= breakpoints.lg) return 'lg';
  if (width >= breakpoints.md) return 'md';
  return 'sm';
};

export const resolveResponsiveValue = (
  val?: string | Partial<Record<BreakpointKey, string>>,
): string | undefined => {
  if (!val) return undefined;
  if (typeof val === 'string') return val;
  const bp = getCurrentBreakpoint();
  // Try current, then fallback to lower breakpoints
  const order: BreakpointKey[] = [bp, 'xl', 'lg', 'md', 'sm'];
  for (const key of order) {
    if (val[key]) return val[key];
  }
  return undefined;
};
